<template>
  <div class="stk-py-6">
    <TaskIndex
      title="Dismissed Tasks"
      status="dismissed"
    />
  </div>
</template>

<script>
import TaskIndex from '@frontend/ui/features/tasks/components/tasks/TaskIndex.vue';

export default {
  name: 'ActionCenterDismissedView',
  components: {
    TaskIndex,
  },
};
</script>
